// import { useModalGeneralHook } from '@salud-front/shared';
import Noticias from './Noticias';
import { useFetchNews } from '../hooks/useFetchNews';

/* 
Ejemplo para configurar variables en 
EDITAR FRAGMENTO DE CÓDIGO

<script>
  var URL_NOTICIA = '/salud/NotInicio/';
  var URL_MAS_NOTICIAS = '/salud/Not/Paginas/Inicio.aspx';
  var MOSTRAR_NOTICIAS_SECUNDARIAS = true;
  // TITULO_NOTICIAS No es necesaria, se puede poner título en la apariencia del webpart o elemento web.
  var TITULO_NOTICIAS = 'Al día con tu salud';
  var CANTIDAD_PRIMARIAS = 2;
  var CANTIDAD_SECUNDARIAS = 2;
</script>
*/

// eslint-disable-next-line no-undef
const URL_NOTICIA_VAR = typeof URL_NOTICIA !== 'undefined' ? URL_NOTICIA : '';

const IndexComponent = () => {
  const [newsData, loadingState] = useFetchNews(URL_NOTICIA_VAR);
  // const { renderModalGeneral, setShowModal, setModalData } = useModalGeneralHook({ showInitial: false });

  // const handleModalCancel = () => {
  //   setShowModal(false);
  // };
  // const handleModalConfirm = () => {
  //   setShowModal(false);
  // };

  // // En este proyecto no estamos usando el modal porque si da error no queremos que interfiera con la página donde está
  // // embebido este componente
  // const handleShowModal = (msg, activeError) => {
  //   // const titulo = activeError ? parseText('sharedResources.Modal.Title.Error') : '';
  //   const icono = activeError ? parseText('sharedResources.Iconos.Exitoso') : parseText('sharedResources.Iconos.Error');
  //   const color = activeError ? parseText('sharedResources.Colores.Verde') : parseText('sharedResources.Colores.rojo');
  //   const mainText = parseText('sharedResources.Modal.Buttons.Aceptar');
  //   const altText = activeError ? '' : parseText('sharedResources.Modal.Buttons.Cerrar');
  //   const msgDef = msg || parseText('sharedResources.Modal.Lead.ErrorSistema');

  //   setModalData({
  //     // titleModal: titulo,
  //     msg: msgDef,
  //     Icono: icono,
  //     noAceptar: parseText('sharedResources.Modal.Bolean.False'),
  //     NoX: '',
  //     colorIco: color,
  //     AltButtonText: altText,
  //     MainButtonText: mainText,
  //   });
  //   setShowModal(true);
  // };

  // const handleCloseActionModal = () => {
  //   setShowModal({
  //     showModal: false,
  //   });
  // };

  return (
    <section id="mainLayout">
      {/*  no usaremos modales en ningún modal: */}
      {/* {renderModalGeneral({
        handleModalCancel,
        handleModalConfirm,
        handleCloseActionModal,
      })} */}
      {/*  No hay noticias: */}
      {!loadingState.loading && newsData.primaryNews.length === 0 && ''}
      {loadingState.loading && parseText('Form.Cargando')}
      {!loadingState.loading && newsData.primaryNews.length > 0 && <Noticias newsData={newsData} />}
    </section>
  );
};

export default IndexComponent;
